import React from "react";
import { Home, PackagePlus, ListChecks, MessageSquare, MapPin, Wallet, Palette, Star, User, LifeBuoy } from "lucide-react";
import DashboardLayout from "../../components/dashboard/DashboardLayout";

const ITEMS = [
  { to: "/customer/dashboard", label: "Home", icon: Home, end: true },
  { to: "/customer/new-order", label: "New Order", icon: PackagePlus },
  { to: "/customer/orders", label: "My Orders", icon: ListChecks },
  { to: "/customer/quotes", label: "My Quotes", icon: MessageSquare },
  { to: "/customer/track", label: "Track Order", icon: MapPin },
  { to: "/customer/wallet", label: "Wallet", icon: Wallet },
  { to: "/customer/designs", label: "Saved Designs", icon: Palette },
  { to: "/customer/reviews", label: "Reviews", icon: Star },
  { to: "/customer/profile", label: "Profile", icon: User },
  { to: "/customer/support", label: "Support", icon: LifeBuoy },
];

export default function CustomerLayout() {
  return <DashboardLayout items={ITEMS} title="Customer" />;
}
